import $api from '../services';

export default {
    getRecords(filters) {
        const { createdAt, type } = filters;
        let obj = {};

        if (createdAt) obj.createdAt = createdAt;
        if (type) obj.type = createdAt;

        obj = JSON.stringify(obj);
        let url = '/system-events?skip=0&limit=50&order=-createdAt';

        return $api.get(url, { filters: obj });
    },
    getShortRecords() {
        return $api.get('/system-events?skip=0&limit=6&order=-createdAt');
    },
    getFiteredRecords(filters) {
        return $api.get(
            '/system-events?skip=0&limit=1000&order=-createdAt',
            filters
        );
    }
};
